import RejectionReasonTypes = Boo.Objects.Enums.RejectionReasonTypes;

export default class RejectionFactory {
    static createRejectionFromReasons(userId: number, rejectionReasons: Boo.Objects.RejectionReason[], note: string = null): Boo.Objects.Rejection {
      return {
        Reasons: rejectionReasons,
        Note: note,
        UserId: userId
      } as Boo.Objects.Rejection;
    }

    static createRejectionReason(reasonType: RejectionReasonTypes, note: string = null): Boo.Objects.RejectionReason {
      return {
        RejectionReasonTypeId: reasonType,
        Note: note
      } as Boo.Objects.RejectionReason;
    }
}
